import {createSvgIcon} from "@mui/material";

const AzureIcon = createSvgIcon(
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        height="1em"
        width="1em"
    >
        <path d="M13.05 4.24L6.56 18.05 2 18l5.09-8.76 5.96-5m.7 1.09L22 19.76H6.74l9.3-1.66-4.87-5.79 2.58-6.98z" />
    </svg>,
'Azure',
);

export default AzureIcon